export default __webpack_public_path__ + "static/media/payroll_ic.667a9833.svg";